export default function NavButton({ label, isActive, onClick }) {
  return (
    <button
      className={`border-2 rounded-lg px-2  py-2  min-w-32  text-sm lg:text-lg lg:px-4 lg:py-3 lg:min-w-44 
        ${isActive ? "bg-primary-yellow" : "bg-white hover:bg-gray-100"}
      `}
      onClick={onClick}
      aria-label={label}
      role="menuitem"
    >
      {label}
    </button>
  );
}
